import { useState, useEffect, useCallback } from "react";
import { SimpleGrid, Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import Loading from "../Component/Loading/loading";
import apiService from "../Method/Update_Service";
import { ThemeProvider } from "@mui/material/styles";
import MUIDataTable from "mui-datatables";
import theme from "../assets/Table/TableTheme";
import options from "../assets/Table/TableOption_NoPrint";
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import InputText from "../Component/Input/Input";
import { EditIcon } from "@chakra-ui/icons";




import {
  Box,
  Flex,
  Text,

} from "@chakra-ui/react";
import CustomSwitch from "../Component/Permission_Card/custom_switch";
const App = () => {
  const { t } = useTranslation();

  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [form, setForm] = useState({
    ID: "",
    LINK: "",
    IS_REQUIRED: false,
    VERSION: "",
    ALLOWED_ACCOUNTS: "",
  });

  const [isEdit, setIsEdit] = useState(false);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const { success, data, error } = await apiService.get();
      if (success) {
        setData(data);
      } else {
        setError(error?.message);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleClear = () => {
    setForm({
      ID: "",
      LINK: "",
      IS_REQUIRED: false,
      VERSION: "",
      ALLOWED_ACCOUNTS: "",
    });
    setIsEdit(false);
    setError(null);
  };

  const handleEdit = (tableMeta) => {
    const row = data[tableMeta.rowIndex];
    setForm({
      ID: row._id,
      LINK: row.LINK,
      IS_REQUIRED: row.IS_REQUIRED,
      VERSION: row.VERSION,
      ALLOWED_ACCOUNTS: row.ALLOWED_ACCOUNTS?.join(", ") || "",
    });
    setIsEdit(true);
  };

  const handleDelete = async (tableMeta) => {
    const row = data[tableMeta.rowIndex];
    await Swal.fire({
      icon: "error",
      title: `${t("Confirm_msg")} ${row.LINK}`,
      focusConfirm: false,
      showCancelButton: true,
      customClass: {
        container: "alertContainer",
        popup: "alertPopUp",
        title: "title",
        confirmButton: "confirm",
        cancelButton: "cancel",
      },
      preConfirm: async () => {
        const { success, error } = await apiService.delete(row._id);
        if (success) {
          setData((prev) => prev.filter((item) => item._id !== row._id));
          handleClear();
        } else {
          setError(error?.message);
        }
      },
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      LINK: form.LINK,
      IS_REQUIRED: form.IS_REQUIRED === "true" || form.IS_REQUIRED === true,
      VERSION: form.VERSION,
      ALLOWED_ACCOUNTS: form.ALLOWED_ACCOUNTS
        ? form.ALLOWED_ACCOUNTS.split(",").map((e) => e.trim())
        : [],
    };

    const apiLink = isEdit ? "UPGRADES_UPDATES" : "ADD_NEW_UPDATE";
    if (isEdit) {
      payload._id = form.ID;
    }

    const { success, error } = await apiService.post(payload, apiLink);

    if (success) {
      if (!isEdit) {
        setData((prev) => [...prev, { ...payload, _id: success.id }]);
      } else {
        setData((prev) =>
          prev.map((item) => (item._id === form.ID ? { ...item, ...payload } : item))
        );
      }
      handleClear();
    } else {
      setError(error?.response?.data?.message || error?.message);
    }
  };
  const [isRequired, setIsRequired] = useState(false);

  const toggleIsRequired = () => setIsRequired((prev) => !prev);
  const tableColumns = [
    {
      name: "_id",
      label: "ID",
      options: { filter: false, sort: false, display: false, viewColumns: false },
    },
    {
      name: "LINK",
      label: t("LINK"),
      options: { filter: false, sort: false },
    },
    {
      name: "IS_REQUIRED",
      label: t("IS_REQUIRED"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div
              style={{
                width: 12,
                height: 12,
                borderRadius: "50%",
                backgroundColor: value === true ? "green" : "red",
              }}
            ></div>
          </div>
        ),
      },
    },
    {
      name: "ALLOWED_ACCOUNTS",
      label: t("ALLOWED_ACCOUNTS"),
      options: { filter: false, sort: false },
    },
    {
      name: "VERSION",
      label: t("VERSION_NO"),
      options: { filter: false, sort: false },
    },
    {
      name: "",
      label: t("Edit"),
      options: {
        filter: false,
        viewColumns: false, sort: false,
        customBodyRender: (value, tableMeta) => (
          <IconButton
            className="TableIcon"
            onClick={() => handleEdit(tableMeta)}>
            <EditIcon />
          </IconButton>
        ),
      },
    },
    {
      name: "",
      label: t("Delete"),
      options: {
        filter: false,
        sort: false, viewColumns: false,
        customBodyRender: (value, tableMeta) => (
          <IconButton
            style={{ color: "red" }}
            onClick={() => handleDelete(tableMeta)}>
            <DeleteIcon />
          </IconButton>
        ),
      },
    },
  ];

  return (
    <ThemeProvider theme={theme}>
      <form onSubmit={handleSubmit}>
        <SimpleGrid columns={{ base: 1, md: 2, lg: 5 }} gap={5} p={5}>
          <InputText
            type="text"
            required
            value={form.LINK}
            labels={t("LINK")}
            onChange={(v) => setForm((f) => ({ ...f, LINK: v }))}
          />
          <InputText
            type="text"
            required
            value={form.VERSION}
            labels={t("VERSION_NO")}
            onChange={(v) => setForm((f) => ({ ...f, VERSION: v }))}
          />
          <InputText
            type="text"
            value={form.ALLOWED_ACCOUNTS}
            labels={t("ALLOWED_ACCOUNTS")}
            onChange={(v) => setForm((f) => ({ ...f, ALLOWED_ACCOUNTS: v }))}
          />


          <Box  >
            <SimpleGrid gap={2} columns={1} className="Permission_Content" style={{ marginInline: "5px" }}>
              <Flex justify="space-between" style={{ paddingInline: "25px" }}  >
                <Text fontSize="md">{t("IS_REQUIRED")}</Text>
                <CustomSwitch checked={isRequired} onChange={toggleIsRequired} />
              </Flex>
            </SimpleGrid>
          </Box>
          <Button type="submit" className="login-btn">
            {t("save")}
          </Button>
        </SimpleGrid>
      </form>

      {error && <p className="error-message">{error}</p>}
      {isLoading && <Loading />}
      {!isLoading && (
        <MUIDataTable
          title=""
          data={data}
          columns={tableColumns}
          options={options}
        />
      )}
    </ThemeProvider>
  );
};










export default App;

